import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrencyRates, getData } from '@yme/api';
import { useIsMount, useWindowSize } from '@yme/common/hooks';
import { setCurrencyRateData } from '@yme/common/redux/common/action';
import { getPartnerDetailsPageState } from '@yme/components/Destinations/PartnerDetailsPage/redux/selectors';
import { buildRequestUrl } from '@yme/components/Destinations/PartnerRelatedExperiences/helpers';
import { getDataForDestinationCard } from '@yme/components/Destinations/UnitRelatedExperience/helpers';
import { RelatedExperiences } from '@yme/components/Destinations/components/RelatedExperiences';
import { QueryParamName } from '@yme/components/Destinations/constants';
import { getCurrencyRate, getIsInAuthor, getRootLang } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
export function PartnerRelatedExperiences({ experiencesRootPath, edpURL, experienceListingPagePath, isRemoveBottomIndent, isCurrencyConverterEnabled, currencyRatesHyperdriveEndpoint, nationalCurrencyCode, }) {
    const dispatch = useDispatch();
    const [destinations, setDestinations] = useState([]);
    const { _path, partnerName } = useSelector(getPartnerDetailsPageState);
    const language = useSelector(getRootLang);
    const isInAuthor = useSelector(getIsInAuthor);
    const currencyRate = useSelector(getCurrencyRate);
    const { isMobileView } = useWindowSize();
    const isMount = useIsMount();
    const { t } = useTranslation();
    useEffect(() => {
        if (!currencyRate && isCurrencyConverterEnabled) {
            getCurrencyRates(`${currencyRatesHyperdriveEndpoint}${nationalCurrencyCode}`).then((result) => {
                dispatch(setCurrencyRateData(result));
            });
        }
    }, [
        currencyRate,
        currencyRatesHyperdriveEndpoint,
        dispatch,
        isCurrencyConverterEnabled,
        nationalCurrencyCode,
    ]);
    useEffect(() => {
        if (!_path || !experiencesRootPath || isMount) {
            return;
        }
        const getPartnerRelateExperience = async () => {
            try {
                const response = await getData(buildRequestUrl(_path, experiencesRootPath));
                const data = response.data?.destinationList?.items ?? [];
                const destinationData = data.map((destination) => getDataForDestinationCard(destination, language, edpURL, isInAuthor, undefined, true));
                setDestinations(destinationData);
            }
            catch (error) { }
        };
        getPartnerRelateExperience();
    }, [_path, edpURL, experiencesRootPath, isInAuthor, isMount, language]);
    if (!_path || !experiencesRootPath || !destinations.length) {
        return null;
    }
    const carouselData = isMobileView ? destinations : destinations.slice(0, 3);
    return (React.createElement(RelatedExperiences, { experiencesData: carouselData, viewAllPath: experienceListingPagePath, itemName: partnerName, searchParamName: QueryParamName.PARTNER_QUERY_PARAM, title: t('destinations_experienceRelatedExperiences_title'), isRemoveBottomIndent: isRemoveBottomIndent }));
}
PartnerRelatedExperiences.displayName = 'PartnerRelatedExperiences_AEMComponent';
